<template>
  <div>
    <!-- 菜单 -->
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>
    <!-- 表格 -->
    <el-table
      :data="recordData"
      border=""
      v-loading="listLoading"
      ref="recordData"
      style="width: 100%"
      class="custom-tbl"
    >
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="REP_Company" label="公司"></el-table-column>
      <el-table-column prop="REP_Name" label="姓名"></el-table-column>
      <el-table-column prop="REP_Position" label="职位"></el-table-column>
      <el-table-column prop="REP_Mobile" label="手机" width="100"></el-table-column>
      <el-table-column prop="REP_Email" label="邮箱"></el-table-column>
      <el-table-column prop="REP_DownTime" label="下载时间"></el-table-column>
    </el-table>
    
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>

  </div>
</template>

<script>
import {
  getResearchReportDownList,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import store from '@/store'
export default {
  data(){
    return {
      topButtonList: [],
      recordData:[],
      listLoading: false,
      filters:{
        ReportIDStr:store.getters.getCurReportIDStr, // 报告ID
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      }
    }
  },
  methods: {       
    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    }, 

    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    handleQuery(){
      this.listLoading = true
      getResearchReportDownList(this.filters).then((res) => {
        if(res.data.success) {
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.recordData = res.data.response.data
          this.listLoading = false
        }
      })
    },

    // 导出
    handleExport(){
      const token = window.localStorage.getItem('Token')
      const url = `${process.env.VUE_APP_BASE_API}/api/ResearchReport/${this.filters.ReportIDStr}/download`
      var xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      xhr.responseType = 'blob' // 返回类型blob
      xhr.setRequestHeader('Authorization', 'Bearer ' + token) // 携带token校验
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response
          var reader = new FileReader()
          reader.readAsDataURL(blob) // 转换为base64
          reader.onload = function (e) {
            var a = document.createElement('a') // 创建一个a标签用于下载
            a.download = '报告下载数据.xls' //文件名
            a.href = e.target.result
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send() // 发送ajax请求
    },
    
  },
  mounted() {
    this.handleQuery()

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
  },
}
</script>

<style>

</style>